export const TelegramSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="72"
    viewBox="0 0 80 72"
    fill="none"
  >
    <path
      d="M15.7037 5.83428C17.8004 2.22402 21.6754 1.4204e-06 25.8689 1.23687e-06L54.1311 0C58.3246 -1.83525e-07 62.1996 2.22401 64.2963 5.83428L78.4274 30.1657C80.5242 33.776 80.5242 38.224 78.4274 41.8343L64.2963 66.1657C62.1996 69.776 58.3246 72 54.1311 72H25.8689C21.6754 72 17.8004 69.776 15.7037 66.1657L1.57256 41.8343C-0.524188 38.224 -0.524188 33.776 1.57256 30.1657L15.7037 5.83428Z"
      fill="#20222A"
    />
    <path
      d="M21.214 12.5378C22.8448 9.72979 25.8586 8 29.1202 8L51.102 8C54.3636 8 57.3774 9.72979 59.0083 12.5378L69.9991 31.4622C71.6299 34.2702 71.6299 37.7298 69.9991 40.5378L59.0083 59.4622C57.3774 62.2702 54.3636 64 51.102 64H29.1202C25.8586 64 22.8448 62.2702 21.214 59.4622L10.2231 40.5378C8.5923 37.7298 8.5923 34.2702 10.2231 31.4622L21.214 12.5378Z"
      fill="url(#paint0_linear_415_23005)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.6499 34.5623C36.0923 31.7554 40.3883 29.905 42.5378 29.0109C48.675 26.4582 49.9503 26.0148 50.7815 26.0002C50.9643 25.9969 51.3731 26.0422 51.6379 26.2571C51.8614 26.4385 51.9229 26.6836 51.9524 26.8556C51.9818 27.0276 52.0185 27.4194 51.9893 27.7256C51.6568 31.22 50.2177 39.7001 49.4856 43.6139C49.1758 45.27 48.5658 45.8253 47.9753 45.8796C46.6919 45.9977 45.7174 45.0315 44.4744 44.2167C42.5294 42.9417 41.4305 42.148 39.5425 40.9039C37.3606 39.466 38.7751 38.6757 40.0185 37.3842C40.344 37.0462 45.9985 31.903 46.1079 31.4365C46.1216 31.3781 46.1343 31.1606 46.0051 31.0458C45.8759 30.9309 45.6851 30.9702 45.5475 31.0014C45.3524 31.0457 42.2452 33.0995 36.2258 37.1627C35.3439 37.7683 34.545 38.0634 33.8292 38.0479C33.0402 38.0309 31.5223 37.6018 30.394 37.235C29.01 36.7851 27.91 36.5473 28.0058 35.7833C28.0557 35.3853 28.6037 34.9783 29.6499 34.5623Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_415_23005"
        x1="40.1111"
        y1="8"
        x2="40.1111"
        y2="63.5847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AABEE" />
        <stop offset="1" stopColor="#229ED9" />
      </linearGradient>
    </defs>
  </svg>
);

export const MailSvg = () => (
  <svg
    width="80"
    height="72"
    viewBox="0 0 80 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7037 5.83428C17.8004 2.22402 21.6754 1.4204e-06 25.8689 1.23687e-06L54.1311 0C58.3246 -1.83525e-07 62.1996 2.22401 64.2963 5.83428L78.4274 30.1657C80.5242 33.776 80.5242 38.224 78.4274 41.8343L64.2963 66.1657C62.1996 69.776 58.3246 72 54.1311 72H25.8689C21.6754 72 17.8004 69.776 15.7037 66.1657L1.57256 41.8343C-0.524188 38.224 -0.524188 33.776 1.57256 30.1657L15.7037 5.83428Z"
      fill="#20222A"
    />
    <path
      d="M21.214 12.5378C22.8448 9.72979 25.8586 8 29.1202 8L51.102 8C54.3636 8 57.3774 9.72979 59.0083 12.5378L69.9991 31.4622C71.6299 34.2702 71.6299 37.7298 69.9991 40.5378L59.0083 59.4622C57.3774 62.2702 54.3636 64 51.102 64H29.1202C25.8586 64 22.8448 62.2702 21.214 59.4622L10.2231 40.5378C8.5923 37.7298 8.5923 34.2702 10.2231 31.4622L21.214 12.5378Z"
      fill="#F4C038"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 30H34C32.8954 30 32 30.8954 32 32V40C32 41.1046 32.8954 42 34 42H46C47.1046 42 48 41.1046 48 40V32C48 30.8954 47.1046 30 46 30ZM34 28C31.7909 28 30 29.7909 30 32V40C30 42.2091 31.7909 44 34 44H46C48.2091 44 50 42.2091 50 40V32C50 29.7909 48.2091 28 46 28H34Z"
      fill="#20222A"
    />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.8791 29.4648L37.8791 34.4648C39.0506 35.6364 40.9501 35.6364 42.1217 34.4648L47.1217 29.4648L48.5359 30.8791L43.5359 35.8791C41.5833 37.8317 38.4175 37.8317 36.4649 35.8791L31.4648 30.8791L32.8791 29.4648Z"
      fill="#20222A"
    />
  </svg>
);
